module.exports = __webpack_public_path__ + "img/icon-lottrackr.c6b102ff.svg";